import React from 'react';
import { Link, matchPath, useHref, useResolvedPath } from "react-router-dom-v5-compat";

/// <summary>
/// Renders a React Router Link or an external anchor tag based on whether the link is internal or external.
/// </summary>
/// <remarks>Must be used within a Router context.</remarks>
export default function InternalOrExternalLink({ label, href }: { label: string; href: string }) {
    const basePath = useHref('.');
    const resolvedPath = useResolvedPath(href).pathname;
    const isInCurrentApp = matchPath(basePath + "*", resolvedPath) !== null;

    return isInCurrentApp
        ? <Link to={ href.substring(basePath.length) } title={ label }>{ label }</Link>
        : <a href={ href } title={ label }>{ label }</a>;
}
